goog.module('yext.developerapps.inquicker.Field');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');

const Field = class {
  /** @param {!jQuery} $el */
  constructor($el) {
    /** @type {!jQuery} */
    this.$viewMode = $el.find('.js-view-mode');

    /** @type {!jQuery} */
    this.$editMode = $el.find('.js-edit-mode');

    this.init();
  }

  /** @return {this} */
  init() {
    this.bindEdit_();
    this.bindCancel_();
    this.bindSubmit_();
  }

  /** @private */
  doSubmit_() {
    throw new Error('doSubmit_ must be implemented');
  }

  /** @private */
  bindEdit_() {
    this.$viewMode.find('.js-edit-btn').on('click', function() {
      this.$viewMode.hide();
      this.$editMode.show();
    }.bind(this));
  }

  /** @private */
  bindCancel_() {
    this.$editMode.find('.js-cancel-edit-btn').on('click', function() {
      this.$editMode.hide();
      this.$viewMode.show();
      this.clearErrors_();
    }.bind(this));
  }

  /** @private */
  bindSubmit_() {
    this.$editMode.on('submit', function(e) {
      e.preventDefault();

      this.clearErrors_();
      this.doSubmit_(this.$editMode.serializeArray())
        .success(function(resp) {
          if (resp['errors']) {
            this.handleErrors_(resp['errors']);
          } else if (resp['error']) {
            this.showGenericError_(resp['error']);
          }
        }.bind(this))
        .error(function() {
          this.showGenericError_(yext.msg('Error saving configuration.'));
        }.bind(this));
    }.bind(this));
  }

  /**
   * @param {string} errorMsg
   * @private
   */
  showGenericError_(errorMsg) {
    this.$editMode.find('.js-general-error').text(errorMsg).show();
  }

  /** @private */
  handleErrors_(errors) {
    errors.forEach(function(error) {
      var field = error['field'];
      var message = error['message'];
      if (field === 'general') {
        this.showGenericError_(message);
      } else {
        var $field = $('.js-' + field + '-field');
        $field.find('.js-field-error')
          .text(message)
          .show();
        $field.find(':input').addClass('error');
      }
    }.bind(this));
  }

  /** @private */
  clearErrors_() {
    this.$editMode.find('.js-general-error, .js-field-error').hide();
    this.$editMode.find(':input').removeClass('error');
  }
};

exports = Field;
